import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { clienteAnaliseFinanceiraStatusPendente, clienteAnaliseFinanceiraStatusEmAnalise, clienteAnaliseFinanceiraStatusConcluida } from '../cliente-analise-financeira-status';

@Component({
    selector: 'sgt-cliente-analise-financeira-status-multiselect',
    templateUrl: './cliente-analise-financeira-status-multiselect.component.html',
    styleUrls: ['./cliente-analise-financeira-status-multiselect.component.less']
})
export class ClienteAnaliseFinanceiraStatusMultiselectComponent implements OnInit {
    /** Status selecionados */
    @Input() statuses: number[];
    /** Ao alterar a seleção dos status */
    @Output() statusesChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Status';
    @Input() checked = 'Status'
    @Input() checkedPlural = 'Status';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum status encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowPendente = true;
    @Input() isShowEmAnalise = true;
    @Input() isShowConcluida = true;

    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-cliente-analise-financeira-status ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os status para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        if (this.isShowPendente) {
            selects.push({
                id: clienteAnaliseFinanceiraStatusPendente.id,
                name: clienteAnaliseFinanceiraStatusPendente.nome,
                classes: 'multiselect-item-cliente-analise-financeira-status multiselect-item-cliente-analise-financeira-status-pendente'
            });
        }
        if (this.isShowEmAnalise) {
            selects.push({
                id: clienteAnaliseFinanceiraStatusEmAnalise.id,
                name: clienteAnaliseFinanceiraStatusEmAnalise.nome,
                classes: 'multiselect-item-cliente-analise-financeira-status multiselect-item-cliente-analise-financeira-status-em-analise'
            });
        }
        if (this.isShowConcluida) {
            selects.push({
                id: clienteAnaliseFinanceiraStatusConcluida.id,
                name: clienteAnaliseFinanceiraStatusConcluida.nome,
                classes: 'multiselect-item-cliente-analise-financeira-status multiselect-item-cliente-analise-financeira-status-concluida'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção dos status */
    onChange() {
        this.statusesChange.emit(this.statuses);
    }
}
